function fixPath(path) {
  return `/${path}`
    .split('/')
    .map(x => x.trim())
    .filter(x => x)
    .join('/')
}

class MockFirebaseObject {
  constructor(path, data) {
    this.path = new MockFirebasePath(path)
    this.data = data

    if (this.data && this.data.id) {
      this.key = this.data.id || ''
    }
  }

  child(arg, Type) {
    const childPath = fixPath(`${this.path.toString()}/${arg}`)

    const parts = arg.split('/')
    if (arg.indexOf('/') !== -1) {
      let childData = this.data

      parts.forEach(path => {
        if (childData && Object.prototype.hasOwnProperty.call(childData, path)) {
          childData = childData[path]
        } else {
          // sub-path not found, bail out
          childData = undefined
        }
      })

      const child = new Type(childPath, childData)
      child._parentPath = arg

      return child
    }

    if (!this.data || !Object.prototype.hasOwnProperty.call(this.data, arg)) {
      const child = new Type(childPath, undefined)
      child._parentPath = arg

      return child
    }

    const child = new Type(childPath, this.data[arg])
    child.key = child.key || childPath.split('/').slice(-1).pop() || ''

    return child
  }
}

class MockDataSnapshot extends MockFirebaseObject {
  get ref() {
    return new MockReference(this.path.toString(), this.data)
  }

  val() {
    return this.data
  }

  exists() {
    return this.data != null
  }

  child(path) {
    return super.child(path, MockDataSnapshot)
  }

  forEach(cb) {
    const data = this.data || {}

    Object.entries(data).forEach(([key, value]) => {
      const childSnapshot = new MockDataSnapshot(`${this.path.toString()}/${key}`, value)
      childSnapshot.key = key

      cb(childSnapshot)
    })
  }
}

class MockReference extends MockFirebaseObject {
  get ref() {
    return this
  }

  child(path) {
    return super.child(path, MockReference)
  }

  once(trigger, cb) {
    if (trigger === 'value') {
      const dataSnapshot = new MockDataSnapshot(this.path.toString(), this.data)

      if (typeof cb === 'function') {
        cb(dataSnapshot)
      } else {
        return Promise.resolve(dataSnapshot)
      }
    }
  }

  on(trigger, cb) {
    if (trigger === 'value') {
      const dataSnapshot = new MockDataSnapshot(this.path.toString(), this.data)
      cb(dataSnapshot)
    }
  }

  off() {
    // no-op
  }

  set(newData) {
    this.data = newData
  }
}

class MockFirebasePath {
  constructor(path) {
    this.path = path
  }

  toString() {
    if (typeof this.path !== 'string') {
      return '/'
    }

    return `/${fixPath(this.path)}`
  }
}

export default MockReference
